import React from "react";

import { Modal, Button, Form, Input } from "antd";

class RecoverLogin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formVisible: false,
      sendDisabled: true,
    }

    this.hasErrors = this.hasErrors.bind(this);
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.submitHandler(values);
        this.props.form.resetFields();
      }
    });
  }

  hasErrors(fieldsError) {
    return Object.keys(fieldsError).some(field => fieldsError[field]);
  }

  render() {
    const { getFieldDecorator, getFieldsError } = this.props.form;

    return (
      <div>
        <Modal
          title="ВОССТАНОВЛЕНИЕ ПАРОЛЯ"
          visible={this.props.isVisible}
          onOk={this.props.okHandler}
          onCancel={this.props.cancelHandler}
          className="modalWrapper"
          width="40em"
          footer={[
            <Button key="cancel" onClick={this.props.cancelHandler}
              style={{ width: "7.5em" }}>
              Отмена
            </Button>,
            <Button
              disabled={
                this.hasErrors(getFieldsError())}
              type="primary" form="pagesRecoverForm" key="submit" htmlType="submit"
              style={{ width: "12em" }}>
              Отправить запрос
            </Button>,
          ]}
        >
          <div style={{ margin: "0.5em 0em 0em 1.5em" }}>Вы потеряли пароль?</div>
          <div style={{ margin: "0em 0em 0.65em 1.5em" }}>
            Введите Ваш логин и получите пароль на Вашу электронную почту</div>
          <div className="formWrapper formWrapperInline">
            <Form id="pagesRecoverForm"
              layout="horizontal"
              onSubmit={this.handleSubmit}
              hideRequiredMark={true}
              style={{ marginLeft: "1.5em" }}>
              <Form.Item
                label={<span
                  style={{ paddingRight: "0.9em", marginRight: "1.0em", width: "3.5em", textAlign: "right", display: "inline-block" }}>
                  <span style={{ color: "red" }}>*</span>Логин:</span>}
                colon={false}>
                {getFieldDecorator("name", {
                  rules: [
                    {
                      type: "string",
                      max: 250,
                      message: "Неверный формат"
                    },
                    {
                      required: true,
                      message: "Необходимо ввести логин",
                      whitespace: true
                    }
                  ]
                })(<Input style={{ width: "15em" }} />)}
              </Form.Item>
            </Form>
          </div>
        </Modal>
      </div>
    );
  }
}

const WrappedRecoverLogin = Form.create({ name: "horizontal_login" })(
  RecoverLogin
);

export default WrappedRecoverLogin;
